import React from 'react';
import ReportTabWithPill from './ReportTabWithPill';
import styles from './PrimaryReportTabList.module.css';
import { ReportStatusPillVariant } from '../../../constants/reports'

export interface ReportTabListItem {
  id: string;
  tabText: string;
  pillVariant: ReportStatusPillVariant;
  pillText: string;
  showBadge?: boolean;
}

export interface ReportTabListProps {
  items: ReportTabListItem[];
  selectedId?: string;
  onItemClick?: (id: string) => void;
  className?: string;
}

const PrimaryReportTabList: React.FC<ReportTabListProps> = ({
  items,
  selectedId,
  onItemClick,
  className = '',
}) => {
  const containerClassName = `${styles.container} ${className}`.trim();

  const handleItemClick = (id: string) => {
    if (onItemClick) {
      onItemClick(id);
    }
  };

  return (
    <div className={containerClassName}>
      {items.map((item) => (
        <div
          key={item.id}
          className={styles.item}
          onClick={() => handleItemClick(item.id)}
        >
          <ReportTabWithPill
            tabText={item.tabText}
            pillVariant={item.pillVariant}
            pillText={item.pillText}
            showBadge={item.showBadge}
            selected={selectedId === item.id}
          />
        </div>
      ))}
    </div>
  );
};

export default PrimaryReportTabList;